export default __webpack_public_path__ + "561e6ea9b7efc2273dfff057844eca5b.svg";